import React, { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk';

import { useCustomerDetails } from '../../../techstyle-shared/react-accounts';
import {
  GlobalLDSymbol,
  useLaunchDarklyContextValue,
} from '../../utils/launchDarkly';

declare global {
  interface Window {
    [GlobalLDSymbol]?: LDClient;
  }
}
export function LaunchDarklyIdentifier() {
  const LDClient = useLDClient();
  const ldContextValue = useLaunchDarklyContextValue();
  useCustomerDetails(['signup_source', 'gender']);

  useEffect(() => {
    if (typeof window !== 'undefined' && !window[GlobalLDSymbol]) {
      window[GlobalLDSymbol] = LDClient;
    }
  }, [LDClient]);

  useQuery({
    queryKey: ['ldContext', ldContextValue],
    queryFn: () => {
      return LDClient?.identify(ldContextValue);
    },
    enabled: !!LDClient?.identify,
  });

  return <></>;
}
